import React, { useState } from 'react'
import classNames from 'classnames'

import { useToggle } from '@app/hooks'
import { LntSelect } from '@app/components/base'
import { DropdownRender } from '@app/components/ExtendedSelects/DropdownRender'

import { SELECT_DROPDOWN_RENDER_TYPE } from '@app/components/base/Select/constants'

import styles from './styles.module.scss'

import type { SubtypesSelectProps } from './types'
import type { FilterOption } from '@app/types/filter'

export const SubtypesSelect: React.FC<SubtypesSelectProps> = ({
  defaultValue,
  onAccept,
  className: outerClassName,
  ...props
}) => {
  const { value: isOpen, setValue: setIsOpen, setUntoggled: handleClose } = useToggle()

  const [selectedOptions, setSelectedOptions] = useState<FilterOption | FilterOption[] | null | undefined>(defaultValue)

  const handleTagClose = (_: any, value: string | undefined): void => {
    if (!Array.isArray(selectedOptions)) return onAccept([])

    onAccept(selectedOptions.filter(option => option.value !== value))
  }

  const handleAccept = (): void => {
    onAccept(selectedOptions)
    handleClose()
  }

  const className = classNames(styles.subtypesSelect, outerClassName)

  return (
    <LntSelect
      { ...props }
      className={ className }
      mode='multiple'
      defaultValue={ defaultValue }
      placeholder='Выберите подтипы'
      placement='bottomRight'
      onTagClose={ handleTagClose }
      open={ isOpen }
      onDropdownVisibleChange={ setIsOpen }
      onChange={ (_, options) => setSelectedOptions(options) }
      onBlur={ handleAccept }
      dropdownRender={ menu => {
        return (
          <DropdownRender
            dropdownRenderType={ SELECT_DROPDOWN_RENDER_TYPE.acceptable }
            menu={ menu }
            onAccept={ handleAccept }
          />
        )
      } }
      strictValue
    />
  )
}
